// Generated by purs version 0.14.1
"use strict";
var $foreign = require("./foreign.js");
var Effect_Uncurried = require("../Effect.Uncurried/index.js");
var runParser = Effect_Uncurried.runEffectFn2($foreign.runParser_);
var mkParser = Effect_Uncurried.runEffectFn1($foreign.mkParser_);
var getResults = Effect_Uncurried.runEffectFn1($foreign.getResults_);
var feed = Effect_Uncurried.runEffectFn2($foreign.feed_);
var parse = function (g) {
    return function (i) {
        return function __do() {
            var p = mkParser(g)();
            feed(p)(i)();
            return getResults(p)();
        };
    };
};
module.exports = {
    feed: feed,
    getResults: getResults,
    mkParser: mkParser,
    parse: parse,
    runParser: runParser,
    mkParser_: $foreign.mkParser_,
    feed_: $foreign.feed_,
    getResults_: $foreign.getResults_,
    log: $foreign.log,
    runParser_: $foreign.runParser_
};
